// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 583 ? "group-foo" : chunkId) + "." + {"380":"a8107d3d","451":"a9dbf2fd","454":"a6e82d0c","496":"64130ae0","583":"bf74e0dd"}[chunkId] + ".js";
};